import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import FacilitiesMaintenanceIndustry from "@/pages/industries/FacilitiesMaintenanceIndustry";
export const Route = createFileRoute("/industries/facilities-maintenance")({ head: ({match}) => pageHead(match.pathname), component: () => (<FacilitiesMaintenanceIndustry />) });
